<template>
	<el-dialog :visible.sync="is_visible" :width="'35%'" @close="close"  title="Email Template Form">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form @submit.prevent="submit" ref="updateStatusForm" v-loading="is_loading">

				<b-row>
					<b-col lg="12">
						<b-form-group label="Template Name">
							<b-form-input v-model="form.notif_temp_title" type="text" required></b-form-input>
						</b-form-group>
					</b-col>
					<b-col lg="12">
						<b-form-group label="Template Content">
							<b-form-textarea type="text" label="Message" placeholder="Enter your message here..."
							v-model="form.notif_temp_message" rows="5" max-rows="10"></b-form-textarea>
						</b-form-group>
					</b-col>
					<!-- 
            <b-col lg="12">
              <b-form-group label="Send to Assigned Advisor Only">
                <b-form-checkbox
                  v-model="form.notif_assign_advisor"
                  switch
                  class="ml-5"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>
          -->

					<b-col lg="12">
						<b-form-group label="Assign to Advisor">
							<b-form-select v-model="form.notif_assign_advisor" :options="assignAdvisorOptions"></b-form-select>
						</b-form-group>
					</b-col>

					<b-col lg="12">
						<b-form-group label="Email Receiver">
							<!-- <b-form-select
                  v-model="form.notif_temp_receiver"
                  :options="userEmailOptions"
                  multiple
                ></b-form-select> -->
							<el-select v-model="form.notif_temp_receiver" placeholder="Receiver" multiple filterable>
								<el-option v-for="item in userEmailOptions" :key="item.value" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</b-form-group>
					</b-col>

					<b-col lg="12">
						<b-form-group label="Trigger Point">
							<el-select v-model="form.triggerPoint" placeholder="Receiver" filterable>
								<el-option :label="'No Selected'" :value="null"></el-option>
								<el-option v-for="([key, value]) in emailTriggerPointOptions" :key="key" :label="value"
									:value="key"></el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col lg="12">
						<b-form-group label="Active or Not Active">
							<b-form-checkbox v-model="form.toggle" switch class="ml-5"></b-form-checkbox>
						</b-form-group>
					</b-col>
					<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
						<b-button variant="primary" class="w-100" @click="submit"> {{ _gHlp.isEmpty(form.notif_temp_id) ?
							'Save' :'Update' }}</b-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</el-dialog>
</template>
<script>

import { Select, Option, Checkbox, Dialog } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { mapState, mapActions } from "pinia";
import { useAccessControlStore } from "@/stores/accessControlStore";
import { useNotificationStore } from '@/stores/notificationStore'

export default {
	components: {
		ValidationObserver,
		ValidationProvider,
		[Dialog.name]: Dialog,
		[Select.name]: Select,
		[Option.name]: Option,
		[Checkbox.name]: Checkbox,
	},
	computed: {
		...mapState(useAccessControlStore, ["userList"]),
		userEmailOptions() {
			return this.userList.map(user => ({
				value: user.email,
				text: user.email,
			}));
		},
		notifReceiver: {
			get() {
				if (Array.isArray(this.form.notif_temp_receiver)) {
					return this.form.notif_temp_receiver.map(Number);
				}
				return [];
			},
			set(val) {
				this.form.notif_temp_receiver = val.map(String);
			},
		},
		assignAdvisorOptions() {
			return [
				{ value: 1, text: "Yes" },
				{ value: 0, text: "No" }
			];
		},
		emailTriggerPointOptions() {
			return Object.entries(_gConst.emailTriggerPoints)
		}
	},
	data() {
		return {
			is_visible: false,
			is_loading: false,
			form: {
				notif_temp_id: null, // Store the id of the existing template
				notif_temp_title: "",
				notif_temp_message: "",
				notif_temp_receiver: [],
				notif_assign_advisor: 0, // Default to No (0)
				triggerPoint: "", // Will be converted to trigger_point before sending
				toggle: true, // Default value for the toggle
			},
		}
	},
	async created() {
	},
	methods: {
		...mapActions(useNotificationStore, ['createTemplate', 'updateTemplate']),
		show(item) {
			if (!_gHlp.isEmpty(item)) {
				this.form = item

				if (Array.isArray(item.notif_temp_receiver)) {
					this.form.notif_temp_receiver = item.notif_temp_receiver;
				} else if (typeof item.notif_temp_receiver === 'string') {
					this.form.notif_temp_receiver = item.notif_temp_receiver.split(',').map(item => item.trim());
				} else {
					this.form.notif_temp_receiver = [];
				}
				this.form.notif_assign_advisor = item.notif_assign_advisor === 1 || item.notif_assign_advisor === '1' ? 1 : 0;
				this.form.triggerPoint = item.trigger_point ?? ''; // Correct assignment
			}
			this.is_visible = true
		},
		close() {
			this.is_visible = false
			this.is_loading = false
			this.form = {
				notif_temp_id: null,
				notif_temp_title: "",
				notif_temp_message: "",
				notif_temp_receiver: [],
				notif_assign_advisor: 0,
				triggerPoint: "",
				toggle: true,
			}
		},
		submit() {
			//CREATE
			this.is_loading = true;
			const formData = {
				...this.form,
				notif_temp_type: 'email', // Adding the type field
				is_active: this.form.toggle ? '1' : '0', // Set is_active based on the toggle state
				notif_temp_receiver: this.form.notif_temp_receiver.join(','), // Convert array to string
				notif_assign_advisor: this.form.notif_assign_advisor ? 1 : 0,
				trigger_point: this.form.triggerPoint, // Rename to trigger_point
			}
			if (!_gHlp.isEmpty(this.form.notif_temp_id)) {
				this.updateTemplate(this.form.notif_temp_id, formData).then(resp => {
					_gNotif.notifySuccess('<b>SMS Template</b> - Successfully Updated.')
					this.is_loading = false;
					this.$emit('closeModal', true)
					this.close();
				}).catch(err => {
					_gNotif.notifySuccess('<b>SMS Template</b> - Failed to Update.')
					this.is_loading = false;
				})
			} else {
				this.createTemplate(formData).then(resp => {
					_gNotif.notifySuccess('<b>SMS Template</b> - Successfully Created.')
					this.is_loading = false;
					this.$emit('closeModal', true)
					this.close();
				}).catch(err => {
					_gNotif.notifySuccess('<b>SMS Template</b> - Failed to Create.')
					this.is_loading = false;
				})
			}
		}
	}
}
</script>